import React from "react";
import {
  InfoOutlined,
  AttachMoneyOutlined,
  BusinessOutlined,
  TransferWithinAStationOutlined,
  LocationOnOutlined,
  CalendarTodayOutlined,
  PersonOutlined,

} from "@mui/icons-material";
import { Box, Divider, Grid, Typography } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useCocCollectionDetailContext } from "contexts/PaymentContexts/CocCollectionContext";
import {  localizeDateTimeShort } from "utils/dateFormats";
import OpenInNewTab from "components/Shared/OpenInNewTab";
import { useAuth } from "hooks";

const CocCollectionBasicDetail = () => {
  const { CocCollectionDetail, loadingCocCollectionDetail } =
    useCocCollectionDetailContext();
  const { isVendor } = useAuth();

  return !loadingCocCollectionDetail ? (
    <>
      <Box padding={3}>
        <Grid container spacing={4}>
          <Grid item xs={3}>
            <InformationTile
              icon={() => <InfoOutlined color="primary" />}
              title="ID"
              subtitle={CocCollectionDetail?.cocCollectionId || "N/A"}
            />
          </Grid>
          {/* Branch */}
          <Grid item xs={3}>
            <InformationTile
              icon={() => <LocationOnOutlined color="primary" />}
              title="Branch"
              subtitle={
                CocCollectionDetail?.branch?._id ? (
                  isVendor ? (
                    <span>{CocCollectionDetail.branch.name}</span>
                  ) : (
                    <OpenInNewTab
                      label={CocCollectionDetail.branch.name}
                      link={`/app/crm/branch/${CocCollectionDetail.branch._id}/detail`}
                      disableIcon
                    />
                  )
                ) : (
                  "N/A"
                )
              }
            />
          </Grid>
                  <Grid item xs={3}>
            <InformationTile
              icon={() => <PersonOutlined color="primary" />}
              title="Added User"
              subtitle={
                CocCollectionDetail?.addedUser?._id ? (
                  isVendor ? (
                    <span>{CocCollectionDetail.addedUser.name}</span>
                  ) : (
                    <OpenInNewTab
                      label={CocCollectionDetail.addedUser.name}
                      link={`/app/crm/user/${CocCollectionDetail.addedUser._id}/detail`}
                      disableIcon
                    />
                  )
                ) : (
                  "N/A"
                )
              }
            />
          </Grid>
          {/* Rest of the information tiles remain unchanged */}
          <Grid item xs={3}>
            <InformationTile
              icon={() => <AttachMoneyOutlined color="primary" />}
              title="Actual Amount"
              subtitle={
                CocCollectionDetail?.actualAmount != null
                  ? `Rs. ${CocCollectionDetail.actualAmount.toFixed(2)}`
                  : "N/A"
              }
            />
          </Grid>
          <Grid item xs={3}>
            <InformationTile
              icon={() => <AttachMoneyOutlined color="primary" />}
              title="Collection Amount"
              subtitle={
                CocCollectionDetail?.collectionAmount != null
                  ? `Rs. ${CocCollectionDetail.collectionAmount.toFixed(2)}`
                  : "N/A"
              }
            />
          </Grid>
        
          {CocCollectionDetail?.bankName?.name && (
            <Grid item xs={3}>
              <InformationTile
                icon={() => <BusinessOutlined color="primary" />}
                title="Bank Name"
                subtitle={CocCollectionDetail?.bankName?.name || "N/A"}
              />
            </Grid>
          )}
          <Grid item xs={3}>
            <InformationTile
              icon={() => <TransferWithinAStationOutlined color="primary" />}
              title="Method"
              subtitle={CocCollectionDetail?.collectionMethod?.name || "N/A"}
            />
          </Grid>

          <Grid item xs={3}>
            <InformationTile
              icon={() => <InfoOutlined color="primary" />}
              title="Remittance Remarks"
              subtitle={CocCollectionDetail?.remittanceRemarks || "N/A"}
            />
          </Grid>
            <Grid item xs={3}>
            <InformationTile
              icon={() => <CalendarTodayOutlined color="primary" />}
              title="Requested Date"
              subtitle={
                localizeDateTimeShort(CocCollectionDetail?.collectionDate) ||
                "N/A"
              }
            />
          </Grid>
          <Grid item xs={3}>
            <InformationTile
              icon={() => <CalendarTodayOutlined color="primary" />}
              title="Updated At"
              subtitle={
                localizeDateTimeShort(CocCollectionDetail?.updatedAt) || "N/A"
              }
            />
          </Grid>
        </Grid>
      </Box>
      {CocCollectionDetail?.financeCollection?.isCollected && (
        <>
          <Divider />
          <Typography variant="h6" padding={2}>
            Finance Collected Detail
          </Typography>
          <Box mt="4" padding={3}>
            <Grid container spacing={4}>
              <Grid item xs={3}>
                <InformationTile
                  icon={() => <CalendarTodayOutlined color="primary" />}
                  title="Collected By"
                  subtitle={
                    CocCollectionDetail?.financeCollection?.createdBy?.name ||
                    "N/A"
                  }
                />
              </Grid>

              <Grid item xs={3}>
                <InformationTile
                  icon={() => <CalendarTodayOutlined color="primary" />}
                  title="Collected Method"
                  subtitle={
                    CocCollectionDetail.financeCollection?.collectionMethod
                      ?.name || "N/A"
                  }
                />
              </Grid>
              {CocCollectionDetail?.financeCollection?.bankName?.name && (
                <Grid item xs={3}>
                  <InformationTile
                    icon={() => <CalendarTodayOutlined color="primary" />}
                    title="Bank Name"
                    subtitle={
                      CocCollectionDetail.financeCollection?.bankName?.name ||
                      "N/A"
                    }
                  />
                </Grid>
              )}
              <Grid item xs={3}>
                <InformationTile
                  icon={() => <CalendarTodayOutlined color="primary" />}
                  title="Collected Date"
                  subtitle={
                    localizeDateTimeShort(
                      CocCollectionDetail?.financeCollection?.updatedAt
                    ) || "N/A"
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </>
  ) : (
    <InfoGridSkeleton />
  );
};

export default CocCollectionBasicDetail;
